export const mobileNumberRegex = /^[6-9]\d{9}$/;
